import * as React from 'react'
import { useCompletion } from 'ai/react'
import { GenerateCopyParams } from './server'

type CopyAssistantOptions = {
  stream?: boolean
  enabled?: boolean
  onFinish?: (prompt: string, completion: string) => void
  id?: string
}

const defaultOptions: CopyAssistantOptions = {
  stream: false,
  enabled: true,
}

export const useCopyAssistant = (options: CopyAssistantOptions) => {
  const { stream, onFinish, enabled } = { ...defaultOptions, ...options }
  const [fullCompletion, setFullCompletion] = React.useState<string | null>(
    null
  )

  const { complete, completion, isLoading, ...rest } = useCompletion({
    api: '/api/ai/copy-assistant',
    onFinish: (_prompt, completion) => {
      if (!stream) setFullCompletion(completion)
      if (onFinish) onFinish(_prompt, completion)
    },
  })

  // const debouncedComplete = React.useMemo(
  //   () =>
  //     debounce((_prompt: string) => {
  //       complete(_prompt)
  //     }, 1200),
  //   [complete]
  // )

  // React.useEffect(() => {
  //   if (isLoading || !enabled || lastestPrompt.current === prompt) {
  //     return
  //   }

  //   debouncedComplete(prompt)

  //   return () => {
  //     if (isLoading) stop()
  //   }
  // }, [prompt, debouncedComplete, isLoading, stop, enabled, completion])
  const typedComplete = React.useCallback(
    (prompt: string, opts: Omit<GenerateCopyParams, 'prompt' | 'stream'>) => {
      if (enabled === false) return
      return complete(prompt, {
        body: {
          ...opts,
          stream,
        },
      })
    },
    [complete, stream, enabled]
  )

  return {
    isLoading,
    completion: stream ? completion : fullCompletion,
    complete: typedComplete,
    ...rest,
  }
}
